export const SocialData=[
{
    platform:"Instagram",
    link:"https://www.instagram.com/p3nt3st_guy/?hl=en",
    icon: require("../../assets/icons/instagram.png"),
},
{
    platform:"Linkedin",
    link:"https://in.linkedin.com/in/shubham-nagdive-686b3699",
    icon: require("../../assets/icons/linkedin.png"),
},
{
    platform:"Twitter",
    link:"https://mobile.twitter.com/pentestguy",
    icon: require("../../assets/icons/twitter.png"),
},
{
    platform:"Facebook",
    link:"https://www.facebook.com/pentestguy/",
    icon: require("../../assets/icons/facebook.png"),
},
{
    platform:"Github",
    link:"https://github.com/pentestguy",
    icon: require("../../assets/icons/github.png"),
},
];